<template>
    <v-autocomplete
        :value="value"
        :items="displayItems"
        :search-input.sync="search"
        :loading="loading"
        :placeholder="placeholder"
        :label="label"
        :clearable="clearable"
        :hide-no-data="!search"
        :dense="dense"
        :outlined="outlined"
        :hide-details="hideDetails"
        item-text="name"
        item-value="id"
        return-object
        no-filter
        no-data-text="Nenhum usuário encontrado"
        @change="onChange"
    >
        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.email" class="caption">{{ item.email }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'AssignUserAutocomplete',

    props: {
        value: {
            type: [Number, String, Object],
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Buscar usuário',
        },
        label: {
            type: String,
            default: '',
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        dense: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: true,
        },
        hideDetails: {
            type: Boolean,
            default: true,
        },
        excludeUserId: {
            type: Number,
            default: null,
        },
        noAssigneeOption: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            items: [],
            search: '',
            loading: false,
            debounceTimer: null,
        };
    },

    computed: {
        displayItems() {
            let items = this.items;
            if (this.value && typeof this.value === 'object' && this.value.id !== 'null' && !items.some(u => u.id === this.value.id)) {
                items = [this.value, ...items];
            }
            if (this.excludeUserId) {
                items = items.filter(u => u.id !== this.excludeUserId);
            }
            if (this.noAssigneeOption) {
                items = [{ id: 'null', name: 'Sem atuante' }, ...items];
            }
            return items;
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val && typeof val === 'object' && val.id !== 'null') {
                    if (!this.items.some(i => i.id === val.id)) {
                        this.items = [val];
                    }
                }
            },
        },
        search(value) {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                this.fetchUsers(value || '');
            }, 300);
        },
    },

    methods: {
        async fetchUsers(q) {
            const term = (q || '').trim();

            if (term.length < 1) {
                this.items = [];
                this.loading = false;
                return;
            }

            try {
                this.loading = true;
                const res = await axios.get('/api/user/assignable', {
                    params: { q: term, perPage: 10 },
                });
                this.items = res.data && res.data.data ? res.data.data.data : [];
            } catch (e) {
                this.items = [];
            } finally {
                this.loading = false;
            }
        },
        onChange(user) {
            if (!user) {
                this.$emit('input', null);
                this.$emit('select', null);
                return;
            }
            this.$emit('input', user);
            this.$emit('select', user);
        },
    },
};
</script>
